import React from "react";
import {connect} from "react-redux";
import Moment from "moment";
import {FormattedMessage} from "react-intl";

import MaterialsIcons from "../../../Icons/MaterialsIcons";
import {toFixedPrice} from "../../jobEditPopup/jobPricingFunctions";
import {getParsedJobOrder} from "../jobOrderFunctions";
import {downloadFile} from "../../../../utilities/download";


const JobPurchaseOrderSuccess = (props) => {

  const {job, purchaseOrderErrorMessage} = props;

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  const downloadOrderClick = () => {
    downloadFile(jobOrder.orderFileUrl, "Purchase Order " + job.id)
  }

  return (
    <div className={"flex flex--column flex--center relative job-payment__content relative"}>
      <div className="job-payment__status flex flex--center">
        <FormattedMessage id={purchaseOrderErrorMessage
          ? "messageBox.errorTitle"
          : "jobBoard.purchaseOrderPopup.generatePOSuccessLabel"}/>
      </div>
      <div className="job-payment__order-id">
        PO ID: <span className="bold">{purchaseOrderErrorMessage ? "-" : jobOrder.orderId}</span>
      </div>
      {purchaseOrderErrorMessage ? (
        <div className="text-center mb-2">
          <p className="font--16 job-payment__container m-0 color-red">
            {purchaseOrderErrorMessage}
          </p>
        </div>
      ) : (
        <div className="text-center mb-2">
          <p className="font--16 job-payment__container color-charcoal m-0">
            <FormattedMessage id="jobBoard.purchaseOrderPopup.generatePOSuccessText"/>
          </p>
          <p className="font--16 job-payment__container color-charcoal m-0 bold">{jobOrder.childFabricatorName}</p>
          <div className="flex flex--center color-gray4 font--16 mt-2">
            <span className="pr-15">Order Date: {(new Moment(jobOrder.orderCreatedAt)).format("MM/DD/YYYY")}</span>
            <span className="pl-15">Payment: ${toFixedPrice(jobOrder.referralAmount)}</span>
          </div>
          {jobOrder.orderFileUrl ? (
            <div className="text-center margin-t24">
              <button className="ui-button5 ui-button5--13 ui-button5--flex ui-button5--flex-icon-left text-uppercase
        ui-button5--flex-icon-left--small ui-button5--gray-border pl-1 pr-1"
                      onClick={downloadOrderClick}>
                <span className="ui-button5__material-icon">{MaterialsIcons.DownloadIcon}</span>
                <FormattedMessage id="paymentPopup.orderButton"/>
              </button>
            </div>
          ) : null}
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {job} = store.jobEditPopupState;
  const {purchaseOrderErrorMessage, purchaseOrderStep} = store.jobPurchaseOrderPopupState;
  return {
    job,
    purchaseOrderErrorMessage,
    purchaseOrderStep, // update order id on change
  };
};

export default (
  connect(mapStateToProps)(JobPurchaseOrderSuccess)
)
